import React from 'react';

import OutlinedTextField from './OutlinedTextField';

const OutlinedTextArea = props => {
  return <OutlinedTextField {...{...props, multiline: true, minRows: 5}} />
};
OutlinedTextArea.displayName = 'OutlinedTextArea';

export default OutlinedTextArea;
